import { useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";

const SyncDocumentDialog = ({ open, form, onClose, onSync }) => {
  const [password, setPassword] = useState("");
  const [confirmed, setConfirmed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) {
      setPassword("");
      setConfirmed(false);
      setLoading(false);
      setError("");
    }
  }, [open]);

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  const handleSync = async () => {
    setLoading(true);
    setError("");
    try {
      await onSync({ password, confirmed });
    } catch (syncError) {
      setError(
        syncError?.response?.data?.message ||
          syncError?.message ||
          "Document synchronization failed",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Sync Document to Production</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          You are about to sync &quot;{form?.label || form?.fileName || "this document"}&quot;
          to the production site.
        </Typography>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Only continue after the document has been fully created, tagged, tested,
          and its signature and notarization flows have also been tested.
        </Alert>
        <FormControlLabel
          control={
            <Checkbox
              checked={confirmed}
              onChange={(event) => setConfirmed(event.target.checked)}
              disabled={loading}
            />
          }
          label="I confirm this document and all signature/notarization flows are fully tested."
          sx={{ alignItems: "flex-start", mb: 2 }}
        />
        <TextField
          autoFocus
          fullWidth
          type="password"
          label="Synchronization Password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          disabled={loading}
          autoComplete="new-password"
        />
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading} variant="outlined">
          Cancel
        </Button>
        <LoadingButton
          loading={loading}
          onClick={handleSync}
          disabled={!confirmed || !password.trim()}
          variant="contained"
          color="error"
        >
          Sync Document
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default SyncDocumentDialog;